



















import { Component, Mixins } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import { datatypes } from "@/components/DataTableGenerico/datatypes";
import { API } from "@/shared/api";
import { MessageService } from "@/shared/services/message-service";
import { ssmHttpService } from "@/shared/services/http-service";
import dinamically_formModule from "@/store/modules/dinamically_form-module";
import { BaseDto } from "@/shared/dtos/base-dto";

@Component({
  components: {},
})
export default class ShowDynamicForm extends Mixins(HelperDinamicallyForm) {
  public item_pantalla: any = {};
  public id_pantalla = 0;
  public id_objeto = 0;

  public async OnCreated() {
    this.ShowLoading();
    /*
    if (this.getparamId().HayParametro) {
      await datos_empresaModule.getdatos_empresa(this.getparamId().Parametro);
      this.item_pantalla = datos_empresaModule.datos_empresa;
    } else {
      try {
        await datos_empresaModule.getdatos_empresas();
        if (datos_empresaModule.datos_empresas.length > 0) {
          this.item_pantalla = datos_empresaModule.datos_empresas[0];
        }
      } catch {}
    }
*/
    this.id_pantalla = Number.parseInt(this.$route.params.id_objeto);

    await dinamically_formModule
      .getdinamically_all_form(this.id_pantalla)
      .catch(() => {});

    if (this.getparamId().HayParametro) {
      this.id_objeto = Number.parseInt(this.$route.params.id);

      await ssmHttpService
        .get(
          API.webApiBase +
            this.datasource_campos.dinamically_FormDto.api_call +
            "/" +
            this.id_objeto
        )
        .then((item) => {
          this.item_pantalla = item;
        });
    }

    //Para la clonacion automatica
    this.BasicElement = this.item_pantalla;
    this.HideLoading();
  }
  public get datasource_campos() {
    return dinamically_formModule.dinamically_all_form;
  }
  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica
    for (
      let index = 0;
      index < this.datasource_campos.form_items.length;
      index++
    ) {
      const element = this.datasource_campos.form_items[index];
      switch (element.datatype) {
        case "datetime":
          this.AddFormItemDataDefaultDate(
            new Date(this.item_pantalla[element.variableName]),
            element.caption,
            element.variableName
          )
            .Dimesiones(12, 10, 4)
            .isRequired();

          break;

        case "number":
          this.AddFormItemDataDefaultNumber(
            this.item_pantalla[element.variableName],
            element.caption,
            element.variableName,
            element.intab,
            element.maxLength
          ).Dimesiones(12, 12, 12);

          break;

        case "string":
          this.AddFormItemDataDefaultString(
            this.item_pantalla[element.variableName],
            element.caption,
            element.variableName,
            element.maxLength
          )
            .isRequired()
            .Dimesiones(12, 10, 4);
          break;
        case "boolean":
          this.AddFormItemDataDefaultBoolean(
            this.item_pantalla[element.variableName],
            element.caption,
            element.variableName,
            element.intab,
            element.caption,
            element.caption
          )
            .isRequired()
            .Dimesiones(12, 10, 4);
          break;
        default:
          this.AddFormItemDataDefaultString(
            this.item_pantalla[element.variableName],
            element.caption,
            element.variableName,
            element.maxLength
          )
            .isRequired()
            .Dimesiones(12, 10, 4);
      }
    }
  }

  public Insertar(object: BaseDto) {
    ssmHttpService
      .post(
        API.webApiBase + this.datasource_campos.dinamically_FormDto.api_call,
        object.toJson()
      )
      .then(() => {
        this.AllSaveOk();
      });
  }

  public Actualizar(object: BaseDto) {
    object.id = this.item_pantalla.id;
    object.id_cliente = this.item_pantalla.id_cliente;
    ssmHttpService
      .put(
        API.webApiBase + this.datasource_campos.dinamically_FormDto.api_call+ "/" + object.id,
        object
      )
      .then(() => {
        this.AllSaveOk();
      });
  }
}
